import { getFactores, getSintomas, getTextos } from "../../api/asistenciaMedicaService";
import { getCanalFromBackend } from "../../api/canalService";
import { getProvincias } from "../../api/direccionService";
import { getServicioFromBackend } from "../../api/servicio";
import { obtenerDatosSocio } from "../../helpers/socioPrincipal";
import { loadStatusModulos } from "../../helpers/statusModulos";
import { StorageManager } from "../../interfaces/ads/storage.manager.interface";
import { Canal } from "../../interfaces/canal.interface";
import { ClasificacionModel } from "../../interfaces/clasificacion.interface";
import { Factor } from "../../interfaces/factor.interface";
import { AsistenciaMedicaActionType } from "../../interfaces/global-state/asistencia.medica.action.type.enum";
import { Provincia } from "../../interfaces/provincia.interface";
import { Servicio } from "../../interfaces/servicio.interface";
import { Sintoma } from "../../interfaces/sintoma.interface";
import { ASISTENCIA_VERSION, CABA, CAPITAL } from "../../utils/constants";
import { inicializarDeshabilitarVersiones, inicializarTextosComponentes } from "../../utils/inicializarUtils";

export const loadSocioPrincipal = async (
    apiRequest: (HttpRequestOptions) => Promise<any>,
    user,
    tipoSocio,
    dispatchAsistenciaMedica
) => {
    try {
        if (tipoSocio && tipoSocio !== 'credencial-compartida') {
            const socioPrincipal = await obtenerDatosSocio(Number(user.userInfo.interlocutorComercial), apiRequest, user)
            dispatchAsistenciaMedica({
                type: AsistenciaMedicaActionType.actualizarUsuario,
                socio: socioPrincipal
            });
            return socioPrincipal;
        }
    } catch (error) {
        console.error('ocurrio un error con el socio principal: ', error);
        throw error;
    }
}

export const loadSintomas = async (
    apiRequest: (HttpRequestOptions) => Promise<any>,
    dispatch,
    setError: React.Dispatch<React.SetStateAction<boolean>>
): Promise<Sintoma[]> => {

    try {
        setError(false)

        const sintomas = await getSintomas(apiRequest)

        dispatch({
            type: AsistenciaMedicaActionType.guardarSintomas,
            sintomas: sintomas
        })

        return sintomas

    } catch (error) {
        console.error('Fallo cargar sintomas: ', error)
        setError(true)
    }
}

// se llama una vez por dia
export const loadCanales = async (
    apiRequest: (HttpRequestOptions) => Promise<any>,
    dispatch,
    storageManager: StorageManager
): Promise<Canal[]> => {

    if (!storageManager) {
        throw new Error("No se proporcionó ningun valor para storageManager");
    }

    try {
        const canalesDate = await storageManager.getDataStorage('fecha-canales')
        const today = new Date();

        let lastUpdateDate = canalesDate ? new Date(canalesDate) : null;

        if (!lastUpdateDate || (today.getTime() - lastUpdateDate.getTime()) >= 24 * 60 * 60 * 1000) {

            const canales = await getCanalFromBackend(apiRequest)
            await storageManager.setDataStorage("canales", JSON.stringify(canales))
            await storageManager.setDataStorage("fecha-canales", today.toISOString())
            dispatch({
                type: AsistenciaMedicaActionType.guardarCanales,
                canales: canales
            })
            return canales
        } else {
            const canalesStr = await storageManager.getDataStorage('canales')
            const canales = JSON.parse(canalesStr)
            dispatch({
                type: AsistenciaMedicaActionType.guardarCanales,
                canales: canales
            })
            return canales
        }

    } catch (error) {
        console.error('Fallo cargar canales: ', error)
        throw error
    }
}

export const loadProvincias = async (
    apiRequest: (HttpRequestOptions) => Promise<any>,
    dispatch,
    setError,
    setLoadingProvinces
): Promise<Provincia[]> => {

    try {
        const provincias = await getProvincias(apiRequest)
        let index = provincias.findIndex(prov => prov.nombre.toUpperCase() == CAPITAL);
        provincias[index].nombre = CABA;

        dispatch({
            type: AsistenciaMedicaActionType.guardarProvincias,
            provincias
        })
        setLoadingProvinces(false)
        return provincias

    } catch (error) {
        console.error('Fallo cargar provincias: ', error)
        dispatch({
            type: AsistenciaMedicaActionType.guardarProvincias,
            provincias: []
        })
        setLoadingProvinces(false)
        setError(true)
    }
}

export const loadFactores = async (
    apiRequest: (HttpRequestOptions) => Promise<any>,
    dispatch,
    storageManager: StorageManager
): Promise<Factor[]> => {

    try {
        const factores = getFactores(apiRequest)

        storageManager.setDataStorage("factores", JSON.stringify(factores));

        dispatch({
            type: AsistenciaMedicaActionType.guardarFactores,
            factores
        })

        return factores
    } catch (error) {
        console.error('Fallo cargar factores: ', error)
    }
}

export const loadServicios = async (
    apiRequest: (HttpRequestOptions) => Promise<any>,
    storageManager: StorageManager,
    dispatch
) => {

    if (!storageManager) {
        return Promise.reject("No se proporcionó ningun valor para storageManager");
    }

    try {
        const servicios = await getServicioFromBackend(apiRequest)
        //TODO hacer un nuevo estado en el context para no llamar dos veces el servicio en el home
        const { clasificaciones, serviciosStorage } = handleServiciosData(servicios)
        storageManager.setDataStorage("servicios", JSON.stringify(serviciosStorage))
        storageManager.setDataStorage("clasificaciones", JSON.stringify(clasificaciones))

        dispatch({
            type: AsistenciaMedicaActionType.guardarServiciosCanales,
            servicios: serviciosStorage,
            clasificaciones: clasificaciones
        })

    } catch (error) {
        console.error('ocurrio un error al cargar servicios: ', error)
        throw error
    }
}

const handleServiciosData = (servicios: Servicio[]) => {

    let clasificaciones: ClasificacionModel[] = [];
    let serviciosStorage = [];

    servicios.forEach((servicio) => {
        servicio.clasificacion.forEach((clasificacion) => {
            clasificaciones.push(clasificacion);
        });
        let servicioStorage = {
            descripcion: servicio.descripcion,
            visibleEnCurso: servicio.visibleEnCurso,
        };
        serviciosStorage.push(servicioStorage);
    });

    return {
        clasificaciones,
        serviciosStorage
    }
}

export const loadDeshabilitarModulosPorVersiones = async (
    isWeb,
    apiRequest: (HttpRequestOptions) => Promise<any>,
    dispatch
) => {
    let version = ASISTENCIA_VERSION();
    let aplicacion = isWeb ? 'web' : 'ads';

    try {
        const deshabilitacion = await loadStatusModulos(version, aplicacion, apiRequest);
        dispatch({
            type: AsistenciaMedicaActionType.setStatusModulos,
            statusModulos: deshabilitacion
        });
    } catch (error) {
        let deshabilitacion = inicializarDeshabilitarVersiones();
        deshabilitacion.version = version;
        deshabilitacion.aplicacion = aplicacion;
        dispatch({
            type: AsistenciaMedicaActionType.setStatusModulos,
            statusModulos: deshabilitacion
        });
    }
}

export const getTextosEditables = async (
    dispatch,
    apiRequest
) => {
    try {
        const textosComponentes = await getTextos(apiRequest);
        dispatch({
            type: AsistenciaMedicaActionType.actualizarTextoComponentes,
            textoComponentes: textosComponentes
        })
    } catch (error: any) {
        const textosComponentesDefault = await inicializarTextosComponentes();
        dispatch({
            type: AsistenciaMedicaActionType.actualizarTextoComponentes,
            textoComponentes: textosComponentesDefault?.componentes
        })
        console.error(error);
    }
}